module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasChanges) ? _c('div', [_c('h1', [_vm._v("Uppdatera uppgifter")]), _vm._v(" "), _c('p', [_vm._v("Vill du uppdatera ditt konto med följande uppgifter?")]), _vm._v(" "), _c('table', _vm._l((_vm.config.changes), function(change) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(change.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.to))])])
  }), 0), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading
    }
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Ja, uppdatera")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Nej")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.goToMyPages
    }
  }, [_vm._v("Gå till mina sidor")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64bff26d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/UpdateAddress.vue
// module id = 985
// module chunks = 0